import { Fuel } from '@/src/api/payg';
import { PAYG_EVENTS } from '@/src/constants/analytics';
import AnalyticsService from '@/src/services/analyticsService';
import { P, Stack } from '@ovotech/element-v5';
import React, { useEffect } from 'react';
import { BaseBalanceCard } from './BaseBalanceCard';
import { StyledDarkGreenLabel } from './styles';

interface Props {
  fuel: Fuel;
}

export const TradMeterBalanceCard = ({ fuel }: Props) => {
  useEffect(() => {
    AnalyticsService.dispatch(
      ...PAYG_EVENTS.balanceCardViewed({ fuel, type: 'trad' }),
    );
  }, [fuel]);

  return (
    <BaseBalanceCard fuel={fuel}>
      <Stack spaceBetween={2}>
        <StyledDarkGreenLabel>Balance unavailable</StyledDarkGreenLabel>
        <P>You’ll need a smart meter to see your balance</P>
      </Stack>
    </BaseBalanceCard>
  );
};
